import './styles.css';

interface LoadingSpinnerProps {
  size?: number;
  color?: string;
  showText?: string | boolean;
}
export const LoadingSpinner = ({
  size,
  color = '#5c416b',
  showText = 'Loading...',
}: LoadingSpinnerProps) => {
  if (color === 'primary') {
    color = '#654b78';
  }
  return (
    <div className="loading-spinner">
      <div
        className="spinner-border"
        role="status"
        style={{ width: size, height: size, color }}
      />
      {showText && <span>{showText}</span>}
    </div>
  );
};
